// @flow

import DataLayerEvent from './DataLayerEvent';
import EventNames from '../../../../constants/DataLayer/EventNames';
import { generateProduct } from '../../helpers';
import type Product from '../../../Product';

export default class ViewCart extends DataLayerEvent {
  /**
   * @inheritDoc
   */
  validate(): boolean {
    return Array.isArray(this.data.products) && this.data.products.length;
  }

  /**
   * @inheritDoc
   */
  dispatch(): void {
    super.dispatch();
    this.push({
      event: EventNames.VIEW_CART,
      ecommerce: {
        items: this.data.products.map((product: Product) => generateProduct(product))
      }
    });
  }
}
